'use client';
import Button from '@/components/Button';
import { Modal } from '@/components/Modal';
import { FaqAccordion } from '../../FaqSection/FaqAccordion';
import './FaqModal.scss';

export function FaqModal({ handleFaqModalClose, isOpen }: { handleFaqModalClose: () => void; isOpen: boolean }) {
  return (
    <div className="faq-modal">
      <Modal closeOnBackdropClick isOpen={isOpen} onClose={handleFaqModalClose}>
        <div className="flex h-full w-full flex-col content-between md:h-[45vh] md:w-96 lg:w-full">
          <h2 className="text-h4 mb-5">
            Have questions? <br /> We have the answers.
          </h2>
          <div className="mb-5 overflow-y-auto overscroll-contain pr-2">
            <FaqAccordion />
          </div>
          <form method="dialog" className="flex w-full">
            <Button variant="primary" className="grow" href="#PricingContactUsSection">
              Request Pricing
            </Button>
          </form>
        </div>
      </Modal>
    </div>
  );
}
